import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RouterProvider from './router/RouterProvider';

/**
 * The main react app
 */
const App = () => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <RouterProvider />
  </LocalizationProvider>
);

export default App;
